import FoodOrdersListPanel from '../../components/food/FoodOrdersListPanel';
import PageShell from '../../components/layout/PageShell';
import PageHeader from '../../components/layout/PageHeader';

export default function MerchantFoodOrderHistoryPage() {
  return (
    <PageShell>
      <PageHeader
        title="Food Order History"
        subtitle="Delivered, cancelled, and past restaurant orders"
      />
      <FoodOrdersListPanel
        scope="history"
        title="Past food orders"
        queryKeyPrefix="merchant-food-history"
      />
    </PageShell>
  );
}
